import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useProcessCategoryMutations } from '../../../hooks/useNomenclatures';

const ProcessCategoryList = ({ items, onUpdate }) => {
  const mutations = useProcessCategoryMutations();

  const fields = [
    { name: 'icon', label: 'Icon', type: 'text', placeholder: '🦠' },
    { name: 'color', label: 'Color', type: 'color' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="process-categories"
      title="Process Categories"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default ProcessCategoryList;

